
<template>
  <div class="pendapatanpurata">
   <v-snackbar
     :timeout="snackbar.timeout"
     :color="snackbar.color"
     v-model="snackbar.show"
   >
     {{ snackbar.message }}
   </v-snackbar>
   <v-card style="margin-top: 250px">
   <v-breadcrumbs :items="item">
     <template v-slot:item="{ item }">
       <v-breadcrumbs-item
         :href="goToRoute(item.href)"
         :disabled="item.disabled"
       >
         {{ item.text }}
       </v-breadcrumbs-item>
     </template>
   </v-breadcrumbs>

   <v-card>
     <v-card-title class="text-h5 grey lighten-2">
       {{ $t("pendapatanpurata") }} {{ title }}
     </v-card-title>

     <v-container>
       <v-form ref="formpendapatanpurata">
         <v-row>
           <v-col cols="12" sm="4">
             <v-autocomplete
               outlined
               dense
               v-bind:label="$t('negeri')"
               return-object
               :items="lookupnegeri"
               :item-text="item => item.negeriID +' - '+ item.negeri"
               item-value="negeriID"
               v-model="paparnegeriexport"
               :disabled="disablenegeri"
               v-on:change="paparlookupsample"
             ></v-autocomplete>
           </v-col>

           <v-col cols="12" sm="3">
             <v-autocomplete
               outlined
               dense
               v-bind:label="$t('sample')"
               return-object
               :items="lookupsample"
               item-text="sample"
               v-model="paparsample"
               ref="fokuspaparsample"
             ></v-autocomplete>
           </v-col>

              <v-col cols="12" sm="3">
             <v-autocomplete
               outlined
               dense
               v-bind:label="$t('pusingan')"
               return-object
               :items="lookuppusingan"
               item-text="pusingan"
               v-model="paparpusinganexport"
             ></v-autocomplete>
           </v-col>
           
           <!-- <v-col cols="12" sm="2" class="black--text"> -->
             <!-- Tahun <span style="color:red;font-weight:bold;font-size: small;"> * </span> -->
                 <!-- <v-text-field
                     v-model="Tahun"
                     outlined
                     dense
                     label="Tahun"
                 ></v-text-field>
           </v-col> -->

           <v-col class="text-right">
            <v-btn
                   color="blue white white--text"
                   @click="cari()">
                   <span class="material-icons">search</span> 
                  {{ $t("cari") }}</v-btn> 
             <!-- &nbsp;&nbsp;

                   <v-btn color="pink white white--text"
                 @click="reset()">
                 <span class="material-icons">reset_tv</span>
                 {{ $t("reset") }}
               </v-btn> -->
             </v-col>
            
             <Overlay v-show="showOverlay"/>

             <v-col v-show="isShowing" class="text-right">
                 <v-btn type="button" color="red white white--text" 
               @click="downloadPDF('pdf')"><span class='fas fa-file-pdf' style='font-size:24px'></span>
               {{ $t("muatturun") }} 
          </v-btn>
           &nbsp;&nbsp;
          
          <v-btn type="button" color="green white white--text"
          @click="downloadExcel('xls')"><span class='fas fa-file-excel' style='font-size:24px'></span>
          {{ $t("muatturun") }} 
          </v-btn></v-col></v-row>
          </v-form>

             <v-card-text>
            
         
         <v-simple-table ref="exportable_table" fixed-header dense
         class="table-bordered" id="table1">
 
            <thead>
              <tr>
                 <th colspan="1" style="text-align: center; border: none;">
                  <img src="https://i.ibb.co/WBrF5yQ/JATANEGARA.png" alt="JataNegara" width="80" height="70">
              </th>
              <th colspan="6" style="text-align: center; border: none;" class="text-h6">
                <strong>SISTEM SURVEI PENDAPATAN, PERBELANJAAN ISI RUMAH DAN KEMUDAHAN ASAS  <br>
                  PENDAPATAN ISI RUMAH BULANAN PURATA </strong>
              </th>
             <th colspan="1" style="text-align: center; border: none;">
              <img src="https://i.ibb.co/bX8FgBj/HIES.png" alt="HIES/BA" width="80" height="70">
              </th>
            </tr>
 
              <tr>
              <th rowspan="2"  style="text-align:center;"><strong>KATEGORI</strong></th>
              <th rowspan="2"  style="text-align:center;"><strong>2016</strong></th>
              <th rowspan="2"  style="text-align:center;"><strong>2019</strong></th>
              <th rowspan="2"  style="text-align:center;"><strong>2022 (TANPA WAJARAN)</strong></th>
              <th rowspan="2"  style="text-align:center;"><strong>2022 (BERWAJARAN)</strong></th>
              <th colspan="3" style="text-align:center;"><strong>KADAR PERTUMBUHAN TAHUNAN DIKOMPAUN (CAGR) (%)</strong></th>
            
              </tr>
              <tr> 
              <th style="text-align:center;" ><strong>2014 - 2016</strong></th>
              <th style="text-align:center;" ><strong>2016 - 2019</strong></th>
              <th style="text-align:center;" ><strong>2019 - 2022</strong></th>
 
              </tr>
              </thead>
              
              <tbody>
                <tr>
                     <td style="text-align:left;"><strong> {{detailNegeri.negeri}}</strong></td>
 
                     <template v-for="item in dataz.data2016" >
                      <td v-if="item.row == '1' && item.col == '2' && item.DP == ''" :key="item.index" style="text-align:center;">
                        {{item.value}} 
                        <!-- negeri : {{item.NG}} row : {{item.row}} col : {{item.col}} -->
                      </td>
                     </template>
                    <template v-for="item in dataz.data2019" >
                     <td v-if="item.row == '1' && item.col == '3' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}} 
                      <!-- negeri : {{item.NG}} row : {{item.row}} col : {{item.col}} -->
                     </td>   
                    </template>
                    
                    <!-- //-- current year and without wajaran 2022-->
                    <td style="text-align:center;">
                      {{calculateJPKASBNeg()}}
                    </td>                
                    <!-- //-- current year and wajaran 2022-->
                    <td style="text-align:center;">
                      {{wajaranNG}}
                    </td>                
 
                    <template v-for="item in dataz.data2015" >
                    <td v-if="item.row == '1' && item.col == '4' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}} <!-- {{item.value}} negeri : {{item.NG}} row : {{item.row}} col : {{item.col}} -->
                      <!-- negeri : {{item.NG}} row : {{item.row}} -->
                    </td>
                     </template>
                     <template v-for="item in dataz.data2018" >
                     <td v-if="item.row == '1' && item.col == '5' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}} 
                      <!-- negeri : {{item.NG}} row : {{item.row}} col : {{item.col}} -->
                     </td>   
                    </template>
                    <!-- //--current year ln calculation 2022-->
                    <td style="text-align:center;">
                      {{calculateCAGR2022Purata('NEG')}}
                    </td>    
 
                  </tr>
                <tr>
                     <td colspan="8" style="text-align:left;"><strong>Strata</strong></td>
                </tr>
                <tr>
                     <td style="text-align:left;">Bandar</td>
 
                    <template v-for="item in dataz.data2016" >
                    <td v-if="item.row == '2' && item.col == '2' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}} 
                      <!-- negeri : {{item.NG}} row : {{item.row}} col : {{item.col}} -->
                    </td>
                    </template>
                     <template v-for="item in dataz.data2019" >
                     <td v-if="item.row == '2' && item.col == '3' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}} 
                      <!-- negeri : {{item.NG}} row : {{item.row}} col : {{item.col}} -->
                     </td>   
                    </template>
                    <!-- //--current year and without wajaran 2022-->
                    <td style="text-align:center;">
                      {{calculateStrata('1')}}
                    </td>
                    <!-- //--current year and wajaran 2022-->
                    <td style="text-align:center;">
                      {{calculateWajaranStrata2022('1')}}
                    </td>
                     <template v-for="item in dataz.data2015" >
                    <td v-if="item.row == '2' && item.col == '4' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}} 
                      <!-- negeri : {{item.NG}} row : {{item.row}} col : {{item.col}} -->
                    </td>
                    </template>
                     <template v-for="item in dataz.data2018" >
                     <td v-if="item.row == '2' && item.col == '5' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}} 
                      <!-- negeri : {{item.NG}} row : {{item.row}} col : {{item.col}} -->
                     </td>   
                    </template>
                    <!-- //--current year and ln calculation 2022-->
                    <td style="text-align:center;">
                      {{calculateCAGR2022Purata('Bandar')}}
                    </td>
                 </tr>
                 <tr>
                     <td style="text-align:left;">Luar Bandar</td>
                    
                    <template v-for="item in dataz.data2016" >
                    <td v-if="item.row == '3' && item.col == '2' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}} 
                    </td>
                    </template>
                     <template v-for="item in dataz.data2019" >
                     <td v-if="item.row == '3' && item.col == '3' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                    </template>
                    <!-- //--current year and without wajaran 2022-->
                    <td style="text-align:center;">
                      {{calculateStrata('2')}}
                    </td>
                    <!-- //--current year and wajaran 2022-->
                    <td style="text-align:center;">
                      {{calculateWajaranStrata2022('2')}}
                    </td>
                     <template v-for="item in dataz.data2015" >
                    <td v-if="item.row == '3' && item.col == '4' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                    </td>
                    </template>
                     <template v-for="item in dataz.data2018" >
                     <td v-if="item.row == '3' && item.col == '5' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                    </template>
                    <!-- //--current year and ln calculation 2022-->
                    <td style="text-align:center;">
                      {{calculateCAGR2022Purata('LuarBandar')}}
                    </td>
                </tr>
                 <tr>
                     <td colspan="8" style="text-align:left;"><strong>Kaum :</strong></td>
                 </tr>
                
                <tr>
                     <td style="text-align:left;">Bumiputra</td>
 
                     <template v-for="item in dataz.data2016" >
                    <td v-if="item.row == '4' && item.col == '2' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}} 
                    </td>
                    </template>
                     <template v-for="item in dataz.data2019" >
                     <td v-if="item.row == '4' && item.col == '3' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                    </template>
                    <!-- //--current year and without wajaran 2022-->
                     <td style="text-align:center;">
                      {{calculateEtnik('1')}}
                    </td>
                    <!-- //--current year and wajaran 2022-->
                    <td style="text-align:center;">
                      {{calculateWajaranEtnik2022('1')}}
                    </td>
                     <template v-for="item in dataz.data2015" >
                    <td v-if="item.row == '4' && item.col == '4' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                    </td>
                    </template>
                     <template v-for="item in dataz.data2018" >
                     <td v-if="item.row == '4' && item.col == '5' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                    </template>
                    <!-- //--current year and ln calculation 2022-->
                    <td style="text-align:center;">
                      {{calculateCAGR2022Purata('KaumBumi')}}
                    </td>
                     
                </tr>
                 <tr>
                     <td style="text-align:left;">Cina</td>
 
                     <template v-for="item in dataz.data2016" >
                    <td v-if="item.row == '5' && item.col == '2' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}} 
                    </td>
                    </template>
                     <template v-for="item in dataz.data2019" >
                     <td v-if="item.row == '5' && item.col == '3' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                    </template>
                    <!-- //--current year and without wajaran 2022-->
                    <td style="text-align:center;">
                      {{calculateEtnik('2')}}
                    </td>
                    <!-- //--current year and wajaran 2022-->
                    <td style="text-align:center;">
                      {{calculateWajaranEtnik2022('2')}}
                    </td>
                     <template v-for="item in dataz.data2015" >
                    <td v-if="item.row == '5' && item.col == '4' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                    </td>
                    </template>
                     <template v-for="item in dataz.data2018" >
                     <td v-if="item.row == '5' && item.col == '5' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                    </template>
                    <!-- //--current year and ln calculation 2022-->
                    <td style="text-align:center;">
                      {{calculateCAGR2022Purata('KaumCina')}}
                    </td>
                </tr>
                 <tr>
                     <td style="text-align:left;">India</td>
 
                    <template v-for="item in dataz.data2016" >
                    <td v-if="item.row == '6' && item.col == '2' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                    </td>
                    </template>
                     <template v-for="item in dataz.data2019" >
                     <td v-if="item.row == '6' && item.col == '3' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                    </template>
                    <!-- //--current year and without wajaran 2022-->
                    <td style="text-align:center;">
                      {{calculateEtnik('3')}}
                    </td>
                    <!-- //--current year and wajaran 2022-->
                    <td style="text-align:center;">
                      {{calculateWajaranEtnik2022('3')}}
                    </td>
                     <template v-for="item in dataz.data2015" >
                    <td v-if="item.row == '6' && item.col == '4' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                    </td>
                    </template>
                     <template v-for="item in dataz.data2018" >
                     <td v-if="item.row == '6' && item.col == '5' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                    </template>
                    <!-- //--current year and ln calculation 2022-->
                    <td style="text-align:center;">
                      {{calculateCAGR2022Purata('KaumIndia')}}
                    </td>
                </tr>
                 <tr>
                     <td style="text-align:left;">Lain-lain</td>
                      <template v-for="item in dataz.data2016" >
                    <td v-if="item.row == '7' && item.col == '2' && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                    </td>
                    </template>
                     <template v-for="item in dataz.data2019" >
                     <td v-if="item.row == '7' && item.col == '3'  && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                    </template>
                    <!-- //--current year and without wajaran 2022-->
                    <td style="text-align:center;">
                      {{calculateEtnik('4')}}
                    </td>
                    <!-- //--current year and wajaran 2022-->
                    <td style="text-align:center;">
                      {{calculateWajaranEtnik2022('4')}}
                    </td>
                     <template v-for="item in dataz.data2015" >
                    <td v-if="item.row == '7' && item.col == '4'  && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                    </td>
                    </template>
                     <template v-for="item in dataz.data2018" >
                     <td v-if="item.row == '7' && item.col == '5'  && item.DP == ''" :key="item.index" style="text-align:center;">
                      {{item.value}}
                     </td>   
                    </template>
                   <!-- //--current year and ln calculation 2022-->
                    <td style="text-align:center;">
                      {{calculateCAGR2022Purata('KaumLain')}}
                    </td>
 
                </tr>
                 <tr>
                     <td colspan="8" style="text-align:left;">
                      <strong>Daerah Pentadbiran :</strong></td>
                      
                </tr>
                <tr v-for="item in datazDaerah" :key="item.index">
                        <!-- ------loop getlistDaerah----  -->
                       <td  style="text-align:left;">{{item.NamaDP }}</td>
                       <!-- -------loop getlookup_jadual ------ -->
                       <td  style="text-align:center;">{{DP(item.NamaDP,2016) }}</td>
                       <td  style="text-align:center;">{{DP(item.NamaDP,2019) }}</td>
                       <!-- ------loop current year 2022 pendapatan purata------- -->
                       <td  style="text-align:center;">{{calculateJPKASBDaerah(item.DP) }}</td> 
                       <!-- ------loop current year wajaran 2022 pendapatan purata------- -->
                       <td  style="text-align:center;">{{calculateWajaranJPKASBDaerah2022(item.DP)}}</td>
                       <!-- -------loop getlookup_jadual ------ -->
                       <td  style="text-align:center;">{{DP(item.NamaDP,2015) }}</td>
                       <td  style="text-align:center;">{{DP(item.NamaDP,2018) }}</td>
                       <!-- ------loop current year 2022 ln % ------- -->
                      <td  style="text-align:center;">{{calculateCAGR2022PurataDaerah(item.DP,3)}}</td>
                                         
                    </tr>
               
                
              </tbody>
            </v-simple-table>
          </v-card-text>
       
      </v-container>
    </v-card>
    </v-card>
  </div>
 </template>
 <script>
import Overlay from '../../components/Overlay'
import i18n from "@/i18n";
import axios from "../../plugins/axios";
import hidServices from "@/services/lookupField";
const negerilookup = new hidServices();
import getPusingan from "@/services/pusingan";
const pusingan = new getPusingan();

export default {
  components: {
  Overlay
},

  async beforeMount(){
  var res = await pusingan.getPusinganDataAll();
  this.lookuppusingan = res;

  this.lookupsample = await pusingan.getSample();
 
},
 Name: "pendapatanpurata",
 computed: {},
 setup() {},
 data: () => ({
   exportthn: "",
   exportbln: "",
   exportps: '',
   exportneg: '',
   snackbar: "",
   showOverlay: false,

   item: [
     {
       text: i18n.t("utama"),
       disabled: false,
       href: `paparanutama`,
     },
     {
       text: 'Pendapatan Isi Rumah Bulanan Purata',
       disabled: true,
       href: "",
     },
   ],
   title: "",
   
   lookupnegeri: [],
   paparsample:"",
   paparpusinganexport: "",
   lookuppusingan: [],
   lookupsample: [],
   paparnegeri: "",
   paparnegeriexport: "",
   disablepusingan: true,
   peranan: "",
   disablenegeri: true,
   disablesample:true,
   dataz: [],
   detailNegeri:"",
   datez: [],
   sortedData:[],
   sortedDataweight:[],
   daerah: "",
   datazDaerah: [],
   datalookupjadual: [],
   dataJR2: [],
   wajaranNG: "",
   lnwajaranNG: "",
   dataW: [],
   dataW2: [],
   Tahun: "",
   isShowing:false,

  }),
 mounted() {
   this.$store.dispatch("localStorageuser");
   this.permulaan();

 },
 methods: {

   goToRoute(url) {
     return `/${i18n.locale}/${url}`;
   },

   downloadPDF: function () {
           
           var sTable = document.getElementById('table1').innerHTML;
     
     var style = "<style>";
     style = style + "body {font: 14px Calibri;}";
     style = style + "table {width: 100%; font: 12px Calibri;}";
     style = style + "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
     style = style + "padding: 2px 3px;text-align: center;}";
     style = style + "</style>";
     
     // CREATE A WINDOW OBJECT.
     var win = window.open( "http://www.domainname.ext/path.png",
                                  "DescriptiveWindowName");
     win.document.write('<html><head>');
     win.document.write('<title>Pendapatan Isi Rumah Rumah Bulanan Purata</title>');   // <title> FOR PDF HEADER.
     win.document.write(style);          // ADD STYLE INSIDE THE HEAD TAG.
     win.document.write('</head>');
     win.document.write('<body>');
     
     win.document.write('<center>');
      win.document.write(`Negeri = `+this.detailNegeri.negeriID +' - '+this.detailNegeri.negeri);
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     
     win.document.write(`Sample = `+this.paparsample.id) 
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     
     win.document.write(`Pusingan = `+this.paparpusinganexport.id);
     win.document.write('<br>');
     win.document.write('<br>');
     
     win.document.write(sTable);         // THE TABLE CONTENTS INSIDE THE BODY TAG.
     win.document.write('</body></html>');
     
     win.document.close(); 	// CLOSE THE CURRENT WINDOW.
     win.setTimeout(function () {
     win.print();    // PRINT THE CONTENTS.
       }, 100)
     },
  
       // downloadExcel(type, fn, dl){
      
    //   var elt = this.$refs.exportable_table;
    //   var wb = XLSX.utils.table_to_book(elt, {sheet:"Sheet Js"});

    //   XLSX.write(wb, {bookType:type, bookSST:true, type: 'base64'})
    //   XLSX.writeFile(wb, fn || ('SheetJSTableExport.' + (type || 'xlsx')));

    // },

    downloadExcel: function () {
    //format xls
    var uri = 'data:application/vnd.ms-excel;base64,';
  
    var base64 = function(s) {
        return window.btoa(unescape(encodeURIComponent(s)))
      },
      format = function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        })
      }
    var sTable = document.getElementById("table1").innerHTML;
    var ctx = {
      worksheet: 'PendapatanPurata',
      table: sTable
    };
 
    var style = "<style>";
    style = style + "body {font: 12px Calibri;}";
    style = style + "table {width: 100%; font: 12px Calibri;}";
    style = style + "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
    style = style + "padding: 2px 3px;text-align: center;}";
    style = style + "</style>";

    var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';

    tab_text = tab_text + '<x:Name>PendapatanPurata</x:Name>';

    tab_text = tab_text + '<x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>';
    tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
    
    tab_text = tab_text + ('<center>');
    tab_text = tab_text + (`Negeri = `+this.detailNegeri.negeriID +' - '+this.detailNegeri.negeri);
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');

    tab_text = tab_text + (`Sample = `+this.paparsample.sample);
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    
    tab_text = tab_text + (`Pusingan = `+this.paparpusinganexport.pusingan);
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');

    tab_text = tab_text + (style); 
    tab_text = tab_text + (sTable);  

    tab_text = tab_text + '</body></html>';
   
    var link = document.createElement("a");
    link.download = "PendapatanPurata.xls";
    link.href = uri + base64(format(tab_text, ctx))
    link.click();
 
    // window.location.href = uri + window.btoa(tab_text);
  
},
//     downloadExcel: function () {
//   var location = 'data:application/vnd.ms-excel;base64,';
// 	var excelTemplate = '<html> ' +
// 		'<head> ' +
// 		'<meta http-equiv="content-type" content="text/plain; charset=UTF-8"/> ' +
// 		'</head> ' +
// 		'<body> ' +
// 		document.getElementById("table1").innerHTML +
// 		'</body> ' +
// 		'</html>'
// 	window.location.href = location + window.btoa(excelTemplate);
// },

    async cari() {
     this.isShowing="true"
     this.showOverlay = true;
     this.findPendapatan()
     this.TanpaWajaran()
     this.lookupDaerah()
     this.Wajaran()
     
    },

   //  async reset() {
   //      this.detailNegeri = ''
   //      this.paparsample = ''
   //      this.paparpusinganexport = ''
   //  },

   async permulaan() {
     //this.negeri = this.paparnegeriexport.negeri; 
     //this.reset();
     this.peranan = this.$store.state.localStorageuser.role;
     this.paparnegeriexport = this.$store.state.localStorageuser.kodneg;
     let negeri = await negerilookup.getNegeri();
     let role = ["PP", "PO", "FE", "RESPONDENT"];
     this.disablenegeri = 
     role.includes(this.peranan) === true 
         ? true 
         : false;
     this.disablesample = role.includes(this.peranan) !== true 
         ? true 
         : false;
     const Negeri = [];
     negeri.data.data.forEach(async function (element) {
       if (element.negeri !== "Admin" && element.negeri !== "Responden") {
         Negeri.push({
           negeriID: `${element.negeriID}`,
           negeri: `${element.negeri}`,
         });
       }
     });
     this.lookupnegeri = Negeri;
   
     for(var i =0;i<this.lookupnegeri.length;i++){
       if(this.lookupnegeri[i].negeriID == this.paparnegeriexport){
         this.detailNegeri = this.lookupnegeri[i];
       }
     }
   },

   async paparlookupsample(){
     
     this.negeri = this.paparnegeriexport.negeri; 
     this.disablesample = false;
     this.paparsample = "";
     this.paparpusinganexport = "";
     //this.paparsampleexport();
   },

   //------lookup daerah & lookup table data 2019 -------------
   async lookupDaerah() {
     try {
       const res = await axios.get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getListDaerah?NG=`+this.detailNegeri.negeriID,{
       });
             this.datazDaerah = res.data.data.listDaerah;
             this.datalookupjadual = res.data.data.datalookupjadual;
             //console.log(this.datazDaerah)
     }
       catch (error) {
       this.errorDialog = true;
       setTimeout(() => (this.errorDialog = false), 2000);
       this.errMessage = "getData : " + error;
     }
   },

 //-------------------lookup table data 2019---------------------------//
 async findPendapatan() {
     try {
       const res = await axios.get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getPendapatan?NG=`
       +this.detailNegeri.negeriID+`&P=`+this.paparpusinganexport.id,{
       });
         this.dataz = res.data.data;
         // console.log(this.dataz)

       }
      catch (error) {
       this.errorDialog = true;
       setTimeout(() => (this.errorDialog = false), 2000);
       this.errMessage = "getData : " + error;
     }
   },


   //-----------------------------table JR2 GETDATA-TANPA WAJARAN & WAJARAN------------------------------------
   async TanpaWajaran() {
     try {
           const res = await axios.get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getPendapatanPurata?NG=`+this.detailNegeri.negeriID+`&P=`
           +this.paparpusinganexport.id+`&S=`+this.paparsample.id,{
           });
           //this.sortedData = res.data.data;
           this.dataW = res.data.data;
           this.wajaranNG = this.calculateWajaranNeg2022();
           this.lnwajaranNG = this.calculatelnWajaranNeg2022();
           this.showOverlay = false;
          }
           catch (error) {
           this.errorDialog = true;
           setTimeout(() => (this.errorDialog = false), 2000);
           this.errMessage = "getData : " + error;
         }
   },

  
// ******************************* TANPA WAJARAN *****************************

   calculateJPKASBNeg(){

      var currData = this.dataW;
      var arrLength = currData.length;
      let jpkasb = 0;
      var totalHID = arrLength;

         for(var i = 0;i < arrLength;i++){
             jpkasb = jpkasb + Number(currData[i].JPKASB);
         }
           var dataToReturn = Number(jpkasb)/Number(totalHID);
               if(isNaN(dataToReturn)){
                       return "-";
               }else{
                       return Math.round(dataToReturn);
               }
   },

   calculateStrata(st){
       //console.log("masuk")
      var currData = this.dataW;
      var arrLength = currData.length;
      let strata = 0;
      var totalHID = 0;
              
       //kira strata (st) bandar = 1 dan luar bandar = 2
       for(var i = 0;i < arrLength ;i++){
         if (st == 1) {
               if (currData[i].ST == 1 || currData[i].ST == 2){
               totalHID = totalHID + 1
               strata = strata + Number(currData[i].JPKASB);
               // console.log(totalHID)
               }
         }
         if (st == 2) {
             if (currData[i].ST == 0 || currData[i].ST >= 3){
               totalHID = totalHID + 1
               strata = strata + Number(currData[i].JPKASB);
               //total = Number(strata.toFixed(1));
               }
         }
       }
         var dataToReturn = Number(strata)/ Number(totalHID);
         if(isNaN(dataToReturn)){
            return "-";
         }else{
           return Math.round(dataToReturn);
         }
     },


   calculateEtnik(et){

       var currData = this.dataW;
       var arrLength = currData.length;
       let etnik = 0;
       var totalHID = 0;
       
       //kira kaum- bumiputra, cina, india dan lain2        
       for(var i = 0;i < arrLength ;i++){
         //Bumiputra
          if (et == 1) {
             //console.log(this.sortedData[i].KKIRB)//console.log(this.sortedData[i].KKIRB <= 499999)
             if (currData[i].KKIRB <= 499999){
                 totalHID = totalHID + 1
                 etnik = etnik + Number(currData[i].JPKASB);
               }
           }
         //Cina
         if (et == 2) {
             if (currData[i].KKIRB >= 511000 && currData[i].KKIRB <= 599999){
                 totalHID = totalHID + 1
                 etnik = etnik + Number(currData[i].JPKASB);
               }
           }
         //India
         if (et == 3) {
             if (currData[i].KKIRB >= 611000 && currData[i].KKIRB <= 699999){
                 totalHID = totalHID + 1
                 etnik = etnik + Number(currData[i].JPKASB);
               }
           }
         //Lain-lain
         if (et == 4) {
             if (currData[i].KKIRB >= 711000 && currData[i].KKIRB <= 999999){
                 totalHID = totalHID + 1
                 etnik = etnik + Number(currData[i].JPKASB);
               }
           }
       }
        var dataToReturn = Number(etnik)/ Number(totalHID);
           if(isNaN(dataToReturn)){
                 return "-";
           }else{
                 return Math.round(dataToReturn);
         }
     },

   //papar value dari table lookup_jadual untuk daerah
   DP(dp,tahun){
     // var total = 0;
     // let daerah = 0;
              
     for(var i = 0;i < this.datalookupjadual.length ;i++){
       // console.log(this.datalookupjadual[i])
         if (this.datalookupjadual[i].NamaDP == dp && this.datalookupjadual[i].Tahun == tahun){
            return this.datalookupjadual[i].value // this.daerah =  Number( this.sortedData[i].NamaDP);
         }
         //console.log("NamaDP : "+this.datalookupjadual[i].NamaDP)
     }
   },

   //kira JPKASB Daerah
   calculateJPKASBDaerah(dp){
     
     var currData = this.dataW;
     var arrLength = currData.length;
     let jpkasbdaerah = 0;
     var totalHID = 0;
           
     for(var i = 0;i <arrLength ;i++){
           //console.log( this.sortedData[i].DP)
       if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
           currData[i].JPKASB = 0;
       }
        if (currData[i].DP == dp){
               totalHID = totalHID + 1
               jpkasbdaerah = jpkasbdaerah + Number(currData[i].JPKASB);
               // total = Number(jpkasb.toFixed(2));
           }
           //console.log("DP : "+this.sortedData[i].DP)
       }
         var dataToReturn = Number(jpkasbdaerah)/ Number(totalHID);
         
         if(isNaN(dataToReturn)){
                 return "-";
         }else{
                 return Math.round(dataToReturn);
         }
   },

   ///////////////////////////////////////////---CALCULATION WAJARAN 2022---///////////////////////////////////////////////////////

     calculateWajaranNeg2022(){

       var currData = this.dataW;
       var arrLength = currData.length;
       var jpkasb = 0;
       var totalWajaran = 0;
       var responwajaran = 0;
       //var totalHID = arrLength;

       for(var i = 0;i < arrLength ;i++){
               totalWajaran = totalWajaran + Number(currData[i].wajaran); // kira jum respon
               console.log("totalWajaran"+"  "+totalWajaran)
               jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
       }
               
               console.log("jpkasb"+"  "+jpkasb)
               console.log("arrLength"+"  "+totalWajaran)
               var dataToReturn = Number(jpkasb)/Number(totalWajaran);
               console.log("dataToReturn"+" "+dataToReturn)
               if(isNaN(dataToReturn)){
                 return "-";
               }else{
                   return Math.round(dataToReturn);
               }
              
     },

     calculateWajaranStrata2022(st){

       var currData = this.dataW;
       var arrLength = currData.length;
       var strata = 0;
       var totalWajaran = 0;
       var totalstrata = 0;
       
       //kira strata (st) bandar = 1 dan luar bandar = 2
       for(var i = 0;i < arrLength ;i++){
         if (st == 1) {
             if (currData[i].ST == 1 || currData[i].ST == 2){
                 //console.log(currData[i].DP+ "  "+currData[i].JPKASB+ "  "+currData[i].wajaran+ "  "+currData[i].ST)
                 totalWajaran = totalWajaran + Number(currData[i].wajaran);
                 strata = strata + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
                 totalstrata = totalstrata + 1;
                 // console.log("totalstrata1=   "+ totalstrata)
               }
         }
         if (st == 2) {
             if (currData[i].ST == 0 || currData[i].ST >= 3){
                 // console.log(currData[i].DP+ "  "+currData[i].JPKASB+ "  "+currData[i].wajaran+ "  "+currData[i].ST)
                 totalWajaran = totalWajaran + Number(currData[i].wajaran);
                 strata = strata + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
                 totalstrata = totalstrata + 1;
                 // console.log("totalstrata2=   "+ totalstrata)
               }
         }
       }
         var dataToReturn = Number(strata)/Number(totalWajaran);
        
           if(isNaN(dataToReturn)){
               return "-";
           }else{
               return Math.round(dataToReturn);
           }
     },

     calculateWajaranEtnik2022(et){

       var currData = this.dataW;
       var arrLength = currData.length;
       var etnik = 0;
       var totalWajaran = 0;
       
       //kira kaum- bumiputra, cina, india dan lain2        
       for(var i = 0;i < arrLength ;i++){
         //Bumiputra
          if (et == 1) {
             //console.log(this.sortedData[i].KKIRB)//console.log(this.sortedData[i].KKIRB <= 499999)
             if (currData[i].KKIRB <= 499999){
                 totalWajaran = totalWajaran + Number(currData[i].wajaran);
                 etnik = etnik + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
               }
           }
         //Cina
         if (et == 2) {
             if (currData[i].KKIRB >= 511000 && currData[i].KKIRB <= 599999){
                 totalWajaran = totalWajaran + Number(currData[i].wajaran);
                 etnik = etnik + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
               }
           }
         //India
         if (et == 3) {
             if (currData[i].KKIRB >= 611000 && currData[i].KKIRB <= 699999){
                 totalWajaran = totalWajaran + Number(currData[i].wajaran);
                 etnik = etnik + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
               }
           }
         //Lain-lain
         if (et == 4) {
             if (currData[i].KKIRB >= 711000 && currData[i].KKIRB <= 999999){
                 totalWajaran = totalWajaran + Number(currData[i].wajaran);
                 etnik = etnik + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
               }
           }
       }
           var dataToReturn = Number(etnik)/ Number(totalWajaran);

             if(isNaN(dataToReturn)){
                   return "-";
             }else{
                   return Math.round(dataToReturn);
           }
     },

     calculateWajaranJPKASBDaerah2022(dp){
     
     var currData = this.dataW;
     var arrLength = currData.length;
     var jpkasbdaerah = 0;
     var totalWajaran = 0;
     // var totaldp = 0;
        
     for(var i = 0;i <arrLength ;i++){
           
       if(currData[i].JPKASB == null || currData[i].JPKASB == "" || currData[i].wajaran == null){
               currData[i].JPKASB = 0;
               currData[i].wajaran = 1;
       }
        if (currData[i].DP == dp){
               // console.log(currData[i].DP+ "  "+currData[i].JPKASB+ "  "+currData[i].wajaran+ "  ")
               totalWajaran = totalWajaran + Number(currData[i].wajaran);
               jpkasbdaerah = jpkasbdaerah + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
               //totaldp = totaldp + 1;
        }
     }
         //console.log("DP=   "+ dp +"    jpkasbdaerah=   "+ jpkasbdaerah)
         //console.log("totalWajaran=   "+ totalWajaran)
         var dataToReturn = Number(jpkasbdaerah)/ Number(totalWajaran);
         
         if(isNaN(dataToReturn)){
                 return "-";
         }else{
                 return Math.round(dataToReturn);
         }
   },


 ///////////////////////////////////////////---ln 2022---///////////////////////////////////////////////////////

  calculatelnWajaranNeg2022(){

       var currData = this.dataW;
       var arrLength = currData.length;
       var jpkasb = 0;
       var totalWajaran = 0;
       var responwajaran = 0;
       var Data19 = this.dataz;
       //var totalHID = arrLength;
       
       for(var i = 0;i < arrLength ;i++){
               totalWajaran = totalWajaran + Number(currData[i].wajaran);
               jpkasb = jpkasb + (Number(currData[i].JPKASB) * Number(currData[i].wajaran));
       }

       // for(var j = 0;j < Data19[j].length ;j++){
       //   if(Data19[j].row == '1' && Data19[j].col == '3' && Data19[j].DP == "")
       //        var k = Data19[j].value;
       // } 
       //     console.log("data2019 = "+ k)       


              var x = Math.log(5522)
              var wajaranNeg = Math.log(Number(jpkasb)/ Number(totalWajaran))

              var dataToReturn = ((Number(x)/wajaranNeg)/this.Tahun)* 100;
             //  console.log("jpkasb=   "+ x +"    jumWajaran=   "+ wajaranNeg)
             //  console.log("tahun=   "+ this.Tahun)
              if(isNaN(dataToReturn)){
                 return "-";
               }else{
                   //return Math.round(dataToReturn);
                   return dataToReturn.toFixed(1);
               }
     },

 calculatelnWajaranStrata2022(st){

         var currData = this.dataW;
         var arrLength = currData.length;
         var strata = 0;
         var totalWajaran = 0;
         var totalstrata = 0;
         
         //kira strata (st) bandar = 1 dan luar bandar = 2
         for(var i = 0;i < arrLength ;i++){
           if (st == 1) {
               if (currData[i].ST == 1 || currData[i].ST == 2){
                   //console.log(currData[i].DP+ "  "+currData[i].JPKASB+ "  "+currData[i].wajaran+ "  "+currData[i].ST)
                   totalWajaran = totalWajaran + Number(currData[i].wajaran);
                   strata = strata + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
                   totalstrata = totalstrata + 1;
                   // console.log("totalstrata1=   "+ totalstrata)
                 }
           }
           if (st == 2) {
               if (currData[i].ST == 0 || currData[i].ST >= 3){
                   // console.log(currData[i].DP+ "  "+currData[i].JPKASB+ "  "+currData[i].wajaran+ "  "+currData[i].ST)
                   totalWajaran = totalWajaran + Number(currData[i].wajaran);
                   strata = strata + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
                   totalstrata = totalstrata + 1;
                   // console.log("totalstrata2=   "+ totalstrata)
                 }
           }
         }
           var dataToReturn = Math.log(strata)/Math.log(totalWajaran);
                   // console.log("strata1=   "+  dataToReturn)
                   // console.log("strata2=   "+  dataToReturn)

             if(isNaN(dataToReturn)){
                 return "-";
             }else{
                 //return Math.round(dataToReturn);
                 return dataToReturn.toFixed(1);
             }
       },

   calculatelnWajaranEtnik2022(et){

       var currData = this.dataW;
       var arrLength = currData.length;
       var etnik = 0;
       var totalWajaran = 0;
       
       //kira kaum- bumiputra, cina, india dan lain2        
       for(var i = 0;i < arrLength ;i++){
         //Bumiputra
          if (et == 1) {
             //console.log(this.sortedData[i].KKIRB)//console.log(this.sortedData[i].KKIRB <= 499999)
             if (currData[i].KKIRB <= 499999){
                 totalWajaran = totalWajaran + Number(currData[i].wajaran);
                 etnik = etnik + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
               }
           }
         //Cina
         if (et == 2) {
             if (currData[i].KKIRB >= 511000 && currData[i].KKIRB <= 599999){
                 totalWajaran = totalWajaran + Number(currData[i].wajaran);
                 etnik = etnik + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
               }
           }
         //India
         if (et == 3) {
             if (currData[i].KKIRB >= 611000 && currData[i].KKIRB <= 699999){
                 totalWajaran = totalWajaran + Number(currData[i].wajaran);
                 etnik = etnik + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
               }
           }
         //Lain-lain
         if (et == 4) {
             if (currData[i].KKIRB >= 711000 && currData[i].KKIRB <= 999999){
                 totalWajaran = totalWajaran + Number(currData[i].wajaran);
                 etnik = etnik + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
               }
           }
       }
             var dataToReturn = Math.log(etnik)/Math.log(totalWajaran);
             
             if(isNaN(dataToReturn)){
                   return "-";
             }else{
                  // return Math.round(dataToReturn);
                  return dataToReturn.toFixed(1);
           }
     },

 calculatelnWajaranJPKASBDaerah2022(dp){
     
     var currData = this.dataW;
     var arrLength = currData.length;
     var jpkasbdaerah = 0;
     var totalWajaran = 0;  
        
     for(var i = 0;i <arrLength ;i++){
           
       if(currData[i].JPKASB == null || currData[i].JPKASB == "" || currData[i].wajaran == null){
               currData[i].JPKASB = 0;
               currData[i].wajaran = 1;
       }
        if (currData[i].DP == dp){
               totalWajaran = totalWajaran + Number(currData[i].wajaran);
               jpkasbdaerah = jpkasbdaerah + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
        }
     }
         var dataToReturn = Math.log(jpkasbdaerah)/Math.log(totalWajaran);
         
         if(isNaN(dataToReturn)){
                 return "-";
         }else{
                 //return Math.round(dataToReturn);
                 return dataToReturn.toFixed(1);
         }
   },

   ///////////////////////////////////////////---MULA PURATA 2022 (CAGR %)---///////////////////////////////////////////////////////
 
 calculateCAGR2022Purata(typeST){

if(this.dataz != ''){
  var row = '';
  var col = '';
  var conBerwajaran = 0;

  //***** Pendapatan Purata CAGR 2022 Jumlah
  if(typeST == 'NEG'){
     row =  "1"  
     col = "3"
     conBerwajaran =this.calculateWajaranNeg2022()
  }
   
 // ***** Pendapatan Purata CAGR 2022 Strata
 if(typeST == 'Bandar'){
          row =  "2"  
          col = "3"
          conBerwajaran = this.calculateWajaranStrata2022('1')
        }
         if(typeST == 'LuarBandar'){
          row =  "3"  
          col = "3"
          conBerwajaran = this.calculateWajaranStrata2022('2')
        }

         // ***** Pendapatan Purata CAGR 2022 Bumiputera
         if(typeST == 'KaumBumi'){
          row =  "4"  
          col = "3"
          conBerwajaran = this.calculateWajaranEtnik2022('1')
        }

        if(typeST == 'KaumCina'){
          row =  "5"  
          col = "3"
          conBerwajaran = this.calculateWajaranEtnik2022('2')
        }

        if(typeST == 'KaumIndia'){
          row =  "6"  
          col = "3"
          conBerwajaran = this.calculateWajaranEtnik2022('3')
        }

        if(typeST == 'KaumLain'){
          row =  "7"  
          col = "3"
          conBerwajaran = this.calculateWajaranEtnik2022('4')
        }

      var currData = this.dataz.data2019;
      var valuePurata = 0;
      // console.log()
      for(var y = 0; y<currData.length; y++){
        if(this.dataz.data2019[y].row == row && this.dataz.data2019[y].col == col ){
            valuePurata = this.dataz.data2019[y].value
        }
      }
        
      var removecomma = valuePurata.replace(/,/g, '')
      var totalPurata = Number(conBerwajaran) / Number(removecomma)
      
     var data = Math.log(totalPurata)
     var dataToReturn = Number(data) / 0.03

         if(isNaN(dataToReturn)){
         return "-";
         }else{
         return dataToReturn.toFixed(1);
         // return dataToReturn.toFixed(1);
  }
}

},
// ------------------------------PURATA  CAGR 2022 DAERAH---------------------------------

calculateCAGR2022PurataDaerah(Daerah,col){
     
     if(this.dataz != ''){
         // console.log(this.dataz.data2019)
      
       let obj = this.dataz.data2019.find(o => o.DP == Daerah && o.col == col);
       var conBerwajaran = obj.value;
       var WajaranDaerah = this.calculateWajaranJPKASBDaerah2022(Daerah,1,1)
       var removecomma = conBerwajaran.replace(/,/g, '')
       var totalPurata = Number(WajaranDaerah) / Number(removecomma)
       var data = Math.log(totalPurata)
       var dataToReturn = Number(data) / 0.03

              if(isNaN(dataToReturn)){
              return "-";
              }else{
              return dataToReturn.toFixed(1);
              // return dataToReturn.toFixed(1);
       }
      }
   
   },

// ..............................................................
 },// end method

 
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
   
 watch:{
    paparnegeriexport(val){ 
     this.detailNegeri = val; 
   },
  //  detailNegeri(){
  //    this.lookupDaerah();
  //    }
 }
};
</script>


<style scoped id ="table_style" type="text/css">
table {
 width: 100%;
 border-collapse: collapse;
 margin: 50px auto;
}
/* tr {
 background: #eee;
} */

td,
th {
 padding: 10px;
 border: 1px solid #ccc;
 text-align: left;
 font-size: 18px;
}
</style>
         